const translations = {
  'about.seo.title': 'The TEFL Iberia Story',
  'about.seo.description':
    'Learn about how we started with TEFL courses in Spain and became one of the best providers in the country hosting courses in Barcelona.',
  'about.sec1.title': 'The TEFL Iberia Story',
  'about.sec2.title': 'How We Started',
  'about.sec2.description':
    'In the summer of 2008 Richard Davie graduated from Edinburgh University and moved to Barcelona in search of adventure and new experiences. After several English teacher jobs and teacher training courses at various academies he had a keen sense of what worked and didn’t work in language schools. He wanted to provide quality training in small groups, where students can feel at home.',
  'about.sec2.text1':
    'He found his perfect location at Languages4Life, undoubtedly the most modern language academy in Spain. Comfortable classrooms, interactive whiteboards, beautiful library, up-to-date MAC computers all make it the perfect home for TEFL Iberia.',
  'about.sec2.text2':
    'And so TEFL Iberia was born in 2012 and has gone from strength to strength, attracting people of all ages and backgrounds to train as teachers and find work in Barcelona.',

  'about.sec3.title': 'What We Do',
  'about.sec3.description':
    'We want to help you along the same path as Richard and all new TEFL students in Barcelona, and provide you with everything you need to get settled:',
  'about.sec3.ben1.title': 'A Rewarding Job',
  'about.sec3.ben1.text':
    'You’ll find a job quickly with our expert advice and local network of school contacts.',
  'about.sec3.ben2.title': 'Comfortable Accommodation',
  'about.sec3.ben2.text': 'Centrally located with like-minded flatmates.',
  'about.sec3.ben3.title': 'A Network Of Friends',
  'about.sec3.ben3.text':
    'You’ll be friends for life with your classmates, and will have access to our larger graduate network.',
  'about.sec3.ben4.title': 'Spanish Bureaucracy',
  'about.sec3.ben4.text':
    'Visas, paperwork, NIE, social security number, bank account. We can take the pain out of these processes!',

  'about.sec3.text1':
    'The school has been a great success and now ranks as one of the top TEFL courses in the world, according to <accentedLink> TEFL course review </accentedLink>. We have also worked with several major university and student publications, promoting TEFL and working abroad.',
  'about.sec3.text2':
    'In 2017 the team took the big decision to get accredited by Trinity College London and become a Trinity CertTESOL provider. The combination of small school ethos and personalised approach with a globally-recognised qualification has made TEFL Iberia one of the most in-demand schools in the world. We strictly adhere to 12 places per group to ensure the best training and experience possible.',

  'about.sec4.title': 'How We Do It',
  'about.sec4.description':
    'We’ve trained hundreds of new teachers and they’ve all got great things to say about the school. They’ll definitely mention:',
  'about.sec4.ben1': 'The small groups (12 maximum, not 20).',
  'about.sec4.ben2':
    'Varied teaching practice with real students (big & small groups, beginner to advanced levels).',
  'about.sec4.ben3': 'Excellent support from our staff.',
  'about.sec4.ben4': 'Being instilled with the confidence to teach.',
  'about.sec4.ben5':
    'The first-class job opportunities available to them afterwards (we work very hard to make TEFL Iberia one of the most well-known TEFL brands).',
  'about.sec4.ben6': 'The internationally recognised qualification.',

  'about.sec5.title': 'Ready To Start Your Overseas <accent>Adventure?</accent>',
  'about.sec5.btn': `Let's Go`,
};

export default translations;
